<ion-accordion-group expand="inset" [value]="'filter'" class="ion-no-margin ion-margin-vertical ion-padding cus-bloc">
  <ion-accordion [value]="'filter'" class="ion-no-margin">
    <ion-item slot="header" lines="none" class="ion-no-margin">
      <ion-label>Filter</ion-label>
      <ion-note class="ion-align-self-center">{{from | date: 'dd. MMM'}} - {{to | date: 'dd. MMM'}}</ion-note>
    </ion-item>
    <ion-card slot="content" class="ion-no-padding ion-no-margin">

      <ion-grid class="ion-no-margin">
        <ion-row class="ion-no-margin">
          <ion-col size="6" class="ion-text-center ion-no-padding">
            <ion-icon name="arrow-back-outline" class="icon-medium"  (click)="months(false)"></ion-icon>
          </ion-col>
          <ion-col size="6" class="ion-text-center ion-no-padding">
            <ion-icon name="arrow-forward-outline" class="icon-medium" (click)="months(true)"></ion-icon>
          </ion-col>

          <ion-col size="6">
            <ion-item lines="none">
              <ion-label id="fromLabel" position="stacked">From</ion-label>
              <ion-input [(ngModel)]="from" type="date" (ionChange)="onDateChange()" aria-labelledby="fromLabel"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="6">
            <ion-item lines="none">
              <ion-label id="toLabel" position="stacked">To</ion-label>
              <ion-input [(ngModel)]="to" type="date" (ionChange)="onDateChange()" aria-labelledby="toLabel"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <div><p>Category</p></div>
        <ion-item lines="none" class="cus-input" (click)="selectItemCategory.open()">
          <app-search-select
            class="truncate"
            title="Select Type"
            [data]="itemCategories.value"
            itemTextField="name"
            [defaultSelect]="true"
            [multiple]="true"
            [capitalize]="true"
            [showInactive]="true"
            [inactiveSelectable]="true"
            #selectItemCategory
            (selectedChange)="this.selectedItemCategories = $event" >
          </app-search-select>
        </ion-item>

        <div><p>State</p></div>
        <ion-item [disabled]="!displayState" lines="none" class="cus-bloc" (click)="selectItemState.open()">
          <app-search-select
            class="truncate"
            title="Select State"
            [data]="itemStates.value"
            itemTextField="name"
            [defaultSelect]="true"
            [multiple]="true"
            [capitalize]="true"
            [selectedIDs]="selectedStateID"
            [showInactive]="true"
            [inactiveSelectable]="true"
            #selectItemState
            (selectedChange)="selectItemStates($event)" >
          </app-search-select>
        </ion-item>

        <div *ngIf="journalsFilter && hasBexioToken()">
          <div><p>Journal ID</p></div>
          <ion-item lines="none" class="cus-bloc" (click)="selectJournal.open()">
            <app-search-select
              title="Select Journals"
              [data]="journals.value"
              itemTextField="id"
              [defaultSelect]="true"
              [multiple]="true"
              [showInactive]="true"
              [inactiveSelectable]="true"
              #selectJournal
              (selectedChange)="onSelectedJournalsChange($event)" >
            </app-search-select>
          </ion-item>
        </div>

        <div><p>User</p></div>
        <ion-item lines="none" class="cus-bloc" (click)="selectUser.open()">
          <app-search-select class="cus-bloc, truncate"
            title="Select User"
            [data]="users.value"
            itemTextField="email"
            [defaultSelect]="true"
            [multiple]="true"
            [showInactive]="true"
            [inactiveSelectable]="true"
            #selectUser
            (selectedChange)="this.selectedUsers = $event" >
          </app-search-select>
        </ion-item>

        <div><p>Currencies</p></div>
        <ion-item lines="none" class="cus-input" (click)="selectedCurrency.open()">
          <app-search-select
            title="Select Currency"
            [data]="currencies.value"
            itemTextField="shortcode"
            [defaultSelect]="true"
            [multiple]="true"
            [showInactive]="true"
            [inactiveSelectable]="true"
            #selectedCurrency
            (selectedChange)="this.selectedCurrencies = $event" >
          </app-search-select>
        </ion-item>
      </ion-grid>
    </ion-card>
  </ion-accordion>

  <ion-grid>
    <ion-row><hr/></ion-row>
    <ion-row>
      <ion-col size="12" class="ion-text-center ion-no-padding">
        <ion-button (click)="emitLoadEvent()" expand="block" class="ion-no-margin" [disabled]="isFilterEmpty()">Load Selected</ion-button>
      </ion-col>
      </ion-row>
  </ion-grid>
</ion-accordion-group>
